export default __webpack_public_path__ + "static/blocks_of_land-8362260c5127766b015ee5bc0d74bd13.svg";